import React from 'react';
import clsx from 'clsx';

import Container from '@common/Container';
import Heading from '@common/Heading';
import Section from '@common/Section';
import Row from '@common/Row';
import Img from '@common/Image';
import Link from '@common/Link';

import Background from '@images/about/background_links.svg';
import Arrow from './Arrow';

const AboutLinkBorder = ({ data }) => {
  const {
    title,
    showTitle,
    list,
    bgColour
  } = data;
  return (
    <Section className={clsx({[`bg-${bgColour} py-5`]: bgColour })}>
      <Container className='position-relative'>
        {(showTitle && title) && <Heading type='h2' className='mx-auto mb-4 col-lg-10 text-center'>{title}</Heading>}
        {list &&
          <div className='position-relative'>
            <Row className='row-cols-lg-2 gy-3 mx-auto' style={{maxWidth: 850}}>
              {list.map(link => (
                <div key={link.id}>
                  <Link to={link.link} className='d-flex flex-column align-items-center bg-white py-4 border-dark-grey-4 border border-2 rounded-3'>
                    {link.image &&
                      <div className={`d-flex justify-content-center`}>
                        <Img
                          image={link.image.gatsbyImageData}
                          file={link.image.file}
                          alt={link.image.description}
                        />
                      </div>
                    }
                    {link.title && <div className='text-center text-black mt-3'>{link.title}</div>}
                    {link.subtitle && <div className='text-center text-black mb-2'>{link.subtitle}</div>}
                    <Arrow colour={link.bgColour}/>
                  </Link>
                </div>
              ))}
            </Row>
            <img alt='' src={Background} style={{position:'absolute', top: '50%', transform: 'translateY(-50%)', zIndex: -1}} className='d-none d-lg-block w-100'/>
          </div>
        }
        
      </Container>
    </Section>
  )
}

export default AboutLinkBorder
